import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/payment-settings";

export const Route = createFileRoute("/admin/_donation-setup/payment-settings")(
  {
    component: Page,
  }
);
